import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { UsersRoutingModule } from './users-routing.module';
import { UsersService } from './users.service';
import { CompaniesService } from '../companies/companies.service';
import { SectorsService } from '../sectors/sectors.service';
import { ServiceFunctionsListComponent } from './service-functions/service-functions-list/service-functions-list.component';
import { ServiceFunctionsComponent } from './service-functions/service-functions.component';
import { ServiceFunctionsFilterComponent } from './service-functions/service-functions-filter/service-functions-filter.component';
import { ServiceFunctionsAddModalComponent } from './service-functions/modals/service-functions-add/service-functions-add.component';
import { ServiceFunctionsEditModalComponent } from './service-functions/modals/service-functions-edit/service-functions-edit.component';
import { UsersComponent } from './users/users.component';
import { UsersFilterComponent } from './users/users-filter/users-filter.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { UsersQualificationComponent } from './users/qualification/qualification.component';
import { UsersCreateComponent } from './users-create/users-create.component';
import { UsersEditComponent } from './users-edit/users-edit.component';
import { UsersCreateEditWidgetComponent } from './components/users-create-edit-widget/users-create-edit-widget.component';
import { UserRoleExpandedPopoverComponent } from './users/components/popovers/user-role-expanded-popover/user-role-expanded-popover.component';
import { PartnerCodePopoverComponent } from './users/components/popovers/partner-code-popover/partner-code-popover.component';

@NgModule({
    declarations: [
        ServiceFunctionsListComponent,
        ServiceFunctionsComponent,
        ServiceFunctionsFilterComponent,
        ServiceFunctionsAddModalComponent,
        ServiceFunctionsEditModalComponent,
        UsersComponent,
        UsersFilterComponent,
        UsersListComponent,
        UsersQualificationComponent,
        UsersCreateComponent,
        UsersEditComponent,
        UsersCreateEditWidgetComponent,
        UserRoleExpandedPopoverComponent,
        PartnerCodePopoverComponent,
    ],
    imports: [CommonModule, UsersRoutingModule, AppUiModule, SharedModule, FormsModule, ReactiveFormsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [UsersService, CompaniesService, SectorsService]
})
export class UsersModule {}
